// Platform-agnostic storage adapter
interface StorageAdapter {
  getItem: (key: string) => Promise<string | null>;
  setItem: (key: string, value: string) => Promise<void>;
  removeItem: (key: string) => Promise<void>;
}

// Web storage implementation
const webStorage: StorageAdapter = {
  getItem: async (key: string) => {
    return localStorage.getItem(key);
  },
  setItem: async (key: string, value: string) => {
    localStorage.setItem(key, value);
  },
  removeItem: async (key: string) => {
    localStorage.removeItem(key);
  },
};

// Always use web storage for now (React Native will have its own implementation)
export const storage: StorageAdapter = webStorage;

// Zustand-compatible storage for persistence
export const zustandStorage = {
  getItem: async (name: string) => {
    const value = await storage.getItem(name);
    return value ? JSON.parse(value) : null;
  },
  setItem: async (name: string, value: any) => {
    await storage.setItem(name, JSON.stringify(value));
  },
  removeItem: async (name: string) => {
    await storage.removeItem(name);
  },
};